import React from "react";
import FetchHelper from "./lib/fetchHelper.js";
import { ProfileAvatar } from "./lib/profileAvatar";
export class MemberProfileImageUploadComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            saving: false,
            fileInputKey: Date.now()
        };
    }
    componentWillUnmount() {
        this.forgetPreview();
    }
    forgetPreview() {
        if (this.state.preview)
            URL.revokeObjectURL(this.state.preview);
    }
    onFileChosen(file) {
        this.forgetPreview();
        this.setState({ selectedFile: file, preview: file ? URL.createObjectURL(file) : undefined, error: undefined });
    }
    save() {
        if (!this.state.selectedFile)
            return;
        this.setState({ saving: true, error: undefined });
        const formData = new FormData();
        formData.append("file", this.state.selectedFile);
        FetchHelper.postFormData('/bpapi/memberprofile/profileimage', formData)
            .then((result) => {
            this.forgetPreview();
            this.setState({ saving: false, selectedFile: undefined, preview: undefined, fileInputKey: Date.now() });
            this.props.onImage(result);
        })
            .catch(() => {
            this.setState({ saving: false, error: "Billedet kunne ikke gemmes. Det skal være en JPG eller PNG på højst 2 MB." });
        });
    }
    render() {
        const { image, initials } = this.props;
        const { saving, selectedFile, preview, error, fileInputKey } = this.state;
        return (React.createElement("div", { className: "bi-card bi-pf-card", id: "member-profile-image-upload" },
            React.createElement("h2", null, "Mit profilbillede"),
            React.createElement("div", { className: "bi-pf-photo" },
                React.createElement(ProfileAvatar, { image: image, preview: preview, initials: initials, large: true }),
                React.createElement("label", { className: "bi-btn bi-btn-outline bi-pf-file" },
                    React.createElement("svg", { width: "20", height: "20", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.75", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true" },
                        React.createElement("rect", { x: "3", y: "4", width: "18", height: "16", rx: "2" }),
                        React.createElement("circle", { cx: "9", cy: "10", r: "2" }),
                        React.createElement("path", { d: "m21 16-5-5-9 9" })),
                    "V\u00E6lg nyt billede",
                    React.createElement("input", { type: "file", key: fileInputKey, accept: ".jpg,.jpeg,.png,image/*", onChange: (e) => { var _a; return this.onFileChosen((_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0]); } }))),
            React.createElement("div", { className: "bi-pf-hint" }, "Da dit profilbillede blandt andet skal anvendes til at vise hvem man er p\u00E5 vagt med, skal det v\u00E6re af dig selv og i stil med et pasbillede."),
            !!error && React.createElement("div", { className: "bi-bv-alert bi-bv-alert-error", role: "alert" }, error),
            React.createElement("div", { className: "bi-pf-actions" },
                React.createElement("button", { type: "button", className: "bi-btn bi-btn-save", disabled: saving || !selectedFile, onClick: () => this.save() }, saving ? React.createElement("i", { className: "fas fa-cog fa-spin" }) : React.createElement("span", null, "Gem")))));
    }
}
